var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"h100"},[_c('el-header',{staticClass:"bg-white",staticStyle:{"height":"50px"}},[_c('doc-header')],1),_c('el-main',{staticStyle:{"padding":"0"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }